(() => {
  const slots = [...document.querySelectorAll('.main-product__info-container > .shopify-app-block')]
    .filter(slot => slot.querySelector(':scope > moonbundle-component[data-moonbundle-bundle-id="68e59e84-8466-4978-a247-b4bd4b8d2f54"]'));

  slots.forEach(slot => {
    let finished = false;
    let settleTimer;
    let resizeObserver;
    let box;
    const mutationObserver = new MutationObserver(findBox);
    const timeout = setTimeout(() => finish(!box || !box.getBoundingClientRect().height), 8000);

    function finish(unavailable) {
      if (finished) return;
      finished = true;
      clearTimeout(timeout);
      clearTimeout(settleTimer);
      mutationObserver.disconnect();
      resizeObserver?.disconnect();
      slot.setAttribute(unavailable ? 'data-hw-bundle-unavailable' : 'data-hw-bundle-ready', '');
    }

    function settled() {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(() => {
        if (!box?.getBoundingClientRect().height) return;
        const fonts = document.fonts?.ready || Promise.resolve();
        Promise.race([fonts, new Promise(resolve => setTimeout(resolve, 1000))])
          .then(() => finish(false));
      }, 200);
    }

    function findBox() {
      if (finished) return;
      const next = slot.querySelector('.moonbundle-box');
      if (!next) return;
      if (box !== next) {
        box = next;
        resizeObserver?.disconnect();
        if ('ResizeObserver' in window) {
          resizeObserver = new ResizeObserver(settled);
          resizeObserver.observe(box);
        }
      }
      settled();
    }

    mutationObserver.observe(slot, { childList: true, subtree: true });
    findBox();
  });
})();
